const PrescriptionDropdown = () => (
  <div className="prescription-dropdown"></div>
);
export default PrescriptionDropdown;
